import {
  CheckboxList,
  Label,
  TrashIcon,
} from "@monsterindia/global-ui-components";
import React, { useState } from "react";
import { Controller } from "react-hook-form";

import { API_ENDPOINT } from "../../../../constants/appConstant";
import { useNetwork } from "../../../../hooks/useNetwork";
import {
  CheckboxOptionType,
  DropdownOptionType,
  MasterDataType,
} from "../../../../types";
import { SingleDropDownController } from "../../../controllers";
import { LanguageCardProps } from "./Language.types";

const LanguageCard = ({
  index,
  totalLength,
  control,
  setValue,
  errors,
  clearErrors,
  languageProficiencyData,
  onLanguageDeleteBtnClickHandler,
}: LanguageCardProps) => {
  const [languageData, setLanguageData] = useState<CheckboxOptionType[] | null>(
    null,
  );
  const [isLanguageDropdownOptionLoading, setIsLanguageDropdownOptionLoading] =
    useState(false);

  const { fetchData: fetchAPI } = useNetwork();

  const LanguageCheckBoxOptionsData = [
    {
      value: "read",
      id: `read-${index}`,
      displayName: "Read",
    },
    {
      value: "write",
      id: `write-${index}`,
      displayName: "Write",
    },
    {
      value: "speak",
      id: `speak-${index}`,
      displayName: "Speak",
    },
  ];

  const languageDropdownOptionsHandler = async (desingation: string) => {
    setIsLanguageDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=LANGUAGE&name=${desingation}`,
      "GET",
    );

    const masterDesingationData = (res.data as any)?.data as MasterDataType[];

    const updatedDesingationData =
      masterDesingationData && masterDesingationData.length > 0
        ? masterDesingationData.map((desingation) => {
            return {
              value: desingation.name,
              id: desingation.uuid,
              text: desingation.name,
            };
          })
        : null;
    setIsLanguageDropdownOptionLoading(false);
    setLanguageData(updatedDesingationData);
  };

  return (
    <div className="l1-flex l1-flex-col l1-gap-2 l1-items-start l1-w-full">
      <div className="l1-flex l1-gap-4 l1-items-center">
        <Label
          labelText="Language"
          isRequired={true}
          className="!l1-text-sm l1-w-full"
        >
          <SingleDropDownController
            isRequired={true}
            name={`language-${index}`}
            control={control}
            isSearchable={true}
            options={languageData || []}
            onChangeHandler={(inputText: string) => {
              languageDropdownOptionsHandler(inputText);
            }}
            isLoading={isLanguageDropdownOptionLoading}
            onSelect={(selected: DropdownOptionType) => {
              clearErrors(`language-${index}`);
              setValue(`language-${index}`, selected);
            }}
            placeholder={"Add language"}
            errorMessage={
              errors?.[`language-${index}`] ? "This field is required" : ""
            }
          />
        </Label>
        <Label
          labelText="Proficiency"
          isRequired={true}
          className="!l1-text-sm l1-w-full"
        >
          <SingleDropDownController
            isRequired={true}
            name={`proficiency-${index}`}
            control={control}
            isSearchable={false}
            options={languageProficiencyData || []}
            onSelect={(selected: DropdownOptionType) => {
              clearErrors(`proficiency-${index}`);
              setValue(`proficiency-${index}`, selected);
            }}
            placeholder={"Select value"}
            errorMessage={
              errors?.[`proficiency-${index}`] ? "This field is required" : ""
            }
          />
        </Label>

        {/* Show delete button only if there are more than one language cards */}
        {totalLength === 1 && index === 0 ? null : (
          <button
            type="button"
            aria-label="Delete language"
            className="l1-h-auto l1-w-4 l1-flex l1-items-center l1-justify-center l1-cursor-pointer"
            onClick={() => onLanguageDeleteBtnClickHandler(index)}
          >
            <TrashIcon width={14} height={14} />
          </button>
        )}
      </div>
      <Controller
        name={`communication-${index}`}
        control={control}
        render={({ field }) => {
          const selectedValues = Array.isArray(field.value) ? field.value : [];
          const checkboxListKey = `${index}-${[...selectedValues].sort().join("|")}`;

          return (
            <div className="l1-flex l1-flex-row l1-gap-1">
              <CheckboxList
                key={checkboxListKey}
                eventChangeHandler={(data: { values: string[] }) => {
                  clearErrors(`communication-${index}`);
                  field.onChange(data.values);
                }}
                id={`communication-${index}`}
                size="small"
                options={LanguageCheckBoxOptionsData}
                defaultChecked={selectedValues}
              />
            </div>
          );
        }}
      />
    </div>
  );
};

export default LanguageCard;
